import * as React from "react";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { ScreenMode } from "../../../models/enums";
import { ILocalization } from "../../../models/localization";
import OpportunityStore from "../../../stores/opportunityStore";
import { Row, Col } from "react-flexbox-grid";
import * as s from "./tabs.css";

interface IParams {
  opId: string;
}


export class LocationTab extends React.Component<{ store: SeekerStore, params: IParams }, {}>{
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<Col xs={4} className={s.tabSubContainerMobile}>
      <div className={s.tab1Mobile}>
        <img className={s.tabIconMobile} src={local.icons.distance} />
        <p>{this._opStore.selectedOp.location}</p>
      </div>
    </Col>)
  }
}


export class TypeTab extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<Col xs={4} className={s.tabSubContainerMobile}>
      <div className={s.tab2Mobile}>
        <img className={s.tabIconMobile} src={local.icons.duration} />
        <p>{this._opStore.selectedOp.positionType}</p>
      </div>
    </Col>)
  }
}


export class ExpLevelTab extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<Col xs={4} className={s.tabSubContainerMobile}>
      <div className={s.tab3Mobile}>
        <img className={s.tabIconMobile} src={local.icons.layers} />
        <p>{local.addJob.expLevel[this._opStore.selectedOp.expLevel]}</p>
      </div>
    </Col>)
  }
}

export class SalaryTab extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<Col xs={4} className={s.tabSubContainerMobile}>
      <div className={s.tab3Mobile}>
        <img className={s.tabIconMobile} src={local.icons.salary} />
        <p>${this._opStore.selectedOp.salaryFrom} {this._opStore.selectedOp.salaryTo ? `- $${this._opStore.selectedOp.salaryTo}` : local.opportunity.hourly}</p>
      </div>
    </Col>)
  }
}

export class TabsVertical extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }

  render(): JSX.Element {
   
    return (<Col xs={12}>
      <Col xs={12} className={s.tabContainerMobile} >
        <LocationTab store={this.props.store} params={this.props.params} />
        <TypeTab store={this.props.store} params={this.props.params} />
        {this._opStore.selectedOp.salaryFrom > 0 && <SalaryTab store={this.props.store} params={this.props.params} />}
        {this._opStore.selectedOp.salaryFrom === 0 && <ExpLevelTab store={this.props.store} params={this.props.params} />}
      </Col>
    </Col>)
  }
}


// WEBPACK FOOTER //
// ./src/components/opportunity/tabsVertical/index.tsx